// extracted by css-extract-rspack-plugin
export default {"shakkerTourWrapper":"shakkerTourWrapper-VX5ibR"};